import { useEffect, useState } from "react";
import { getCookieConsentValue } from "react-cookie-consent";
import { COOKIE_NAME } from "config";

/** Returns true when the user has accepted cookie consent. Re-renders on acceptance. */
export function useCookieConsent(): boolean {
  const [hasConsent, setHasConsent] = useState(
    () => getCookieConsentValue(COOKIE_NAME) === "true",
  );

  useEffect(() => {
    const handler = () => setHasConsent(true);
    window.addEventListener("cookieConsentAccepted", handler);
    return () => window.removeEventListener("cookieConsentAccepted", handler);
  }, []);

  return hasConsent;
}
